'use client'

import { useStoreI18n } from '@/store'
import { Typo3Image, Typo3Section } from '@/types/typo3'
import { Container, Img, Section } from '@/ui/components'
import { memo } from 'react'

interface SectionAuthorProps extends React.HTMLAttributes<HTMLDivElement> {
  image: Typo3Image[]
  author: string
  text: string
  section: Typo3Section
}

const SectionAuthor = ({
  section,
  image,
  author,
  text,
  ...props
}: SectionAuthorProps) => {
  const D = useStoreI18n.use.dictionary()

  if (!image || !author) {
    return null
  }

  return (
    <Section
      data={section}
      anim="fade-in"
      className="s-section-author pt-2xl pb-4xl bg-neutral-200"
      {...props}
    >
      <Container className="flex justify-center text-center">
        <div className="max-w-168">
          {image && image?.length > 0 && (
            <div className="mb-lg relative mx-auto h-16 w-16 overflow-hidden rounded-full">
              <Img
                data={image[0]}
                sizes={`5rem`}
                className="h-full w-full"
                fill
                objectFit
              />
            </div>
          )}
          <div>
            {author && (
              <p className="textstyle-lg-bold mb-2xs text-neutral-600">
                {`${D['fe.events.filters.resultsFrom']} ${author}`}
              </p>
            )}
            {text && (
              <p className="textstyle-md-regular text-neutral-400">{text}</p>
            )}
          </div>
        </div>
      </Container>
    </Section>
  )
}

export default memo(SectionAuthor)
